import { useJobApplicationStore } from '@core/jobApplication/useJobApplicationStore';
import JobApplicationItem from '../jobApplication/JobApplicationItem';
import Skeleton from '../shared/Skeleton';
import { useFeatureView } from '@/hooks';
import { getJobDetailView } from '@/modules/jobs/views/jobDetail.view';

const JobApplications = ({ jobId }: { jobId: string }) => {
  const { getJobApplicationsForJob, isLoading } = useJobApplicationStore();
  const jobApplications = getJobApplicationsForJob(jobId);
  const view = useFeatureView(getJobDetailView);

  return (
    <div className="mt-6 rounded-lg bg-white p-6 shadow-sm">
      <h2 className="mb-4 text-lg font-semibold">Job Applications</h2>
      {isLoading ? (
        <div className="animate-pulse">
          <Skeleton height="h-4" width="w-full" />
        </div>
      ) : (
        <>
          {jobApplications.length > 0 ? (
            <div className="space-y-4">
              {jobApplications.map((application) => (
                <JobApplicationItem
                  key={application.id}
                  application={application}
                  showClientName={view.actions.showClientName}
                  showWorkerLink={view.actions.showWorkerLink}
                  showApplicantInsights={view.actions.showApplicantInsights}
                  showApplicantDocuments={view.actions.showApplicantDocuments}
                />
              ))}
            </div>
          ) : (
            <p className="text-gray-500">No applications received yet</p>
          )}
        </>
      )}
    </div>
  );
};

export default JobApplications;
